import clsx from 'clsx';
interface ILogoProps {
  id?: string;
  width?: string;
  height?: string;
  className?: string;
  fill?: string;
}

export const Logo = (props: ILogoProps) => {
  return (
    <svg
      className='logoAnimation'
      id={props.id}
      width={props.width || '69px'}
      height={props.height || '29px'}
      viewBox='0 0 69 29'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g fill='none' fillRule='evenodd'>
        <path
          fill={clsx(props.fill ? props.fill : '#ffffff')}
          d='M61.123 27.926l-2.126-5.375H48.402l-2.01 5.375h-7.193L50.683.55h6.42L68.47 27.926h-7.347zM53.777 7.858L48.41 22.544h3.288l1.696-5.29h3.785l-3.402-9.396z'
        />
        <path fill='#a73f33' d='M.675 27.926V.55l6.65 4.296v23.08z' />
        <path
          fill={clsx(props.fill ? props.fill : '#ffffff')}
          d='M37.18 24.321c-1.211 1.392-2.707 2.494-4.485 3.306-1.779.812-3.828 1.218-6.148 1.218-2.114 0-4.067-.348-5.858-1.044-1.792-.696-3.345-1.682-4.66-2.958-1.314-1.276-2.345-2.803-3.093-4.582-.747-1.778-1.121-3.737-1.121-5.877 0-2.191.38-4.176 1.14-5.955.76-1.778 1.811-3.293 3.152-4.543 1.34-1.25 2.913-2.21 4.717-2.88C22.63.335 24.574 0 26.663 0c1.933 0 3.834.342 5.703 1.025 1.869.683 3.383 1.682 4.543 2.996l-4.485 4.486a5.551 5.551 0 0 0-2.436-1.895 8.08 8.08 0 0 0-3.093-.619c-1.16 0-2.224.213-3.19.638a7.483 7.483 0 0 0-2.494 1.76 8.015 8.015 0 0 0-1.624 2.648c-.387 1.019-.58 2.133-.58 3.345 0 1.237.193 2.372.58 3.403.386 1.03.921 1.914 1.604 2.648a7.226 7.226 0 0 0 2.456 1.721c.954.412 1.998.619 3.132.619 1.314 0 2.462-.258 3.441-.774.98-.515 1.766-1.185 2.359-2.01l4.601 4.33z'
        />
      </g>
    </svg>
  );
};
